import Request from "@/common/net/request.js";
const request = new Request();
// 未出账订单列表
export function getPage(data) {
  return request.send({
    url: `/pmy/freight/settlement/supplier/un-settle/orders`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 平台生成对账单
export function reconciliationOrder(data) {
  return request.send({
    url: `/pmy/freight/settlement/supplier/generate`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
